// French translations
export const fr = {
  // Navigation
  'nav.overview': 'Aperçu',
  'nav.dashboard': 'Tableau de bord',
  'nav.analytics': 'Analyses',
  'nav.reportingDashboard': 'Tableau de bord de reporting',
  'nav.sales': 'Ventes',
  'nav.salesOrders': 'Commandes de vente',
  'nav.purchase': 'Achats',
  'nav.purchaseOrders': 'Commandes d\'achat',
  'nav.purchaseReview': 'Espace de vérification',
  'nav.purchase.sprints': 'Sprints',
  'nav.supplierOnboarding': 'Intégration fournisseur',
  'nav.po': 'BC',
  'nav.po.sprints': 'Sprints',
  'nav.po.newSprint': 'Créer un sprint',
  'nav.scout': 'Scout',
  'nav.scout.wochenplanung': 'Planification hebdomadaire',
  'nav.scout.tagesplanung': 'Planification quotidienne',
  'nav.scout.prequal': 'Appels PreQual',
  'nav.scout.missionen': 'Missions',
  'nav.scout.missionControl': 'Centre de contrôle',
  'nav.scout.unternehmenssuche': 'Recherche d\'entreprises',
  'nav.scout.preferences': 'Préférences',
  'nav.scout.hilfe': 'Aide',
  'nav.scout.scorecard': 'Tableau de bord',
  'nav.poSprints': 'BC/Sprints',
  'nav.wiki': 'Wiki',
  'nav.supportVisualization': 'Visualisation du support',
  'nav.navigationTiles': 'Tuiles de navigation',
  'nav.styleGuide': 'Guide de style',
  'nav.inventory': 'Stock',
  'nav.items': 'Articles',
  'nav.warehouse': 'Entrepôt',
  'nav.picking': 'Préparation de commandes',
  'nav.asn': 'ASN',
  'nav.returns': 'Retours',
  'nav.accounting': 'Comptabilité',
  'nav.accountsReceivable': 'Comptes clients',
  'nav.crm': 'CRM',
  'nav.leads': 'Prospects',
  'nav.contacts': 'Contacts',
  'nav.ai': 'IA',
  'nav.commandCenter': 'Centre de commande',
  'nav.workflows': 'Workflows',
  'nav.workflowManagement': 'Gestion des workflows',
  'nav.projectManagement': 'Gestion de projet',
  'nav.support': 'Support',
  'nav.tickets': 'Tickets',
  'nav.pivotTable': 'Tableau croisé dynamique',
  'nav.learning': 'Formation',
  'nav.curriculumPlanning': 'Planification du programme',
  'nav.learnerDashboard': 'Tableau de bord apprenant',
  'nav.accessibleLearnerDashboard': 'Tableau de bord apprenant accessible',
  'nav.settings': 'Paramètres',
  'nav.general': 'Général',
  'nav.company': 'Entreprise',
  'nav.addressManagement': 'Gestion des adresses',
  'nav.usersRoles': 'Utilisateurs et rôles',
  'nav.auditLog': 'Journal d\'audit',
  'nav.integrations': 'Intégrations',
  'nav.appOverview': 'Aperçu des applications',
  'nav.appOverviewDescription': 'Cliquez sur une application pour naviguer, ou glissez les tuiles pour les réorganiser',
  'header.help': 'Aide',
  'header.account': 'Compte',
  'header.portalName': 'Portail CLANDA',
  'header.preferences': 'Préférences',
  'header.language': 'Langue',

  // Help page

  // Privacy page

  // Form

  // Placeholders
  
  // Status
  
  // Actions
  'action.delete': 'Supprimer',
  
  // Messages
  'message.success': 'Succès',
  'message.error': 'Erreur',
  
  // Common
  'common.yes': 'Oui',
  'common.no': 'Non',
  'common.cancel': 'Annuler',
  'common.confirm': 'Confirmer',
  'common.save': 'Enregistrer',
  'common.saveChanges': 'Enregistrer les modifications',
  'common.close': 'Fermer',
  'common.reset': 'Réinitialiser',
  'common.back': 'Retour',
  'common.loading': 'Chargement...',
  'common.search': 'Rechercher',
  'common.search.placeholder': 'Rechercher...',
  'common.filter': 'Filtrer',
  'common.sort': 'Trier',
  'common.add': 'Ajouter',
  'common.delete': 'Supprimer',
  'common.edit': 'Modifier',
  'common.error': 'Erreur',
  'common.remove': 'Retirer',
  'common.minutesShort': '{{value}} min',
  'common.na': 'N/D',
  'common.days': 'jours',
  'common.status.active': 'actif',
  'common.status.paused': 'en pause',
  'common.status.stopped': 'arrêté',
  'common.status.pending': 'en attente',
  'common.status.completed': 'terminé',
  'common.status.planned': 'Planifié',
  'common.status.inProgress': 'En cours',
  'common.status.done': 'Terminé',
  'common.apply': 'Appliquer',
  'common.actions.filter': 'Filtrer',
  'common.actions.export': 'Exporter',
  'common.actions.search': 'Rechercher',
  'common.dialog.defaultTitle': 'Dialogue',
  'common.all': 'Tous',
  'common.total': 'Total',
  'common.pending': 'En attente',
  'common.assigned': 'Attribué',
  'common.inProgress': 'En cours',
  'common.completed': 'Terminé',
  'common.cancelled': 'Annulé',
  'common.approved': 'Approuvé',
  'common.rejected': 'Rejeté',
  'common.processing': 'Traitement',
  'common.overdue': 'En retard',
  'common.partial': 'Partiel',
  'common.highPriority': 'Priorité haute',
  'common.tableView': 'Vue tableau',
  'common.cardView': 'Vue carte',
  'common.switchToTable': 'Passer à la vue tableau',
  'common.switchToCard': 'Passer à la vue carte',
  'common.openMenu': 'Ouvrir le menu',
  'common.details': 'Détails',
  'common.overview': 'Aperçu',
  'common.new': 'Nouveau',
  'common.draft': 'Brouillon',
  'common.shipped': 'Expédié',
  'common.delivered': 'Livré',
  'common.received': 'Reçu',
  'common.inTransit': 'En transit',
  'common.itemsPicked': 'Articles préparés',
  'common.totalRefund': 'Remboursement total',
  'common.totalPrice': 'Prix total',
  'common.orderSummary': 'Résumé de la commande',
  'common.subtotal': 'Sous-total :',
  'common.tax': 'Taxe :',
  'common.discount': 'Remise :',
  'common.totalColon': 'Total :',

  // Date Range Filter (canonical component)
  'dateRange.today': 'Aujourd\'hui',
  'dateRange.yesterday': 'Hier',
  'dateRange.last7Days': '7 derniers jours',
  'dateRange.last14Days': '14 derniers jours',
  'dateRange.last30Days': '30 derniers jours',
  'dateRange.thisMonth': 'Ce mois-ci',
  'dateRange.custom': 'Personnalisé',

  // Dashboard
  'widget.vsLastPeriod': 'vs période précédente',
  'table.showing': 'Affichage',
  'table.of': 'sur',
  'table.page': 'Page',
  'table.previous': 'Précédent',
  'table.next': 'Suivant',
  'table.filterGroups': 'Groupes de filtres',
  'table.addFilterGroup': 'Ajouter un groupe de filtres',
  'table.filterGroup': 'Groupe de filtres',
  'table.addCondition': 'Ajouter une condition',
  'table.operator': 'Opérateur',
  'table.field': 'Champ',
  'table.noFilterGroups': 'Aucun groupe de filtres.',
  'filter.operator.equals': 'est égal à',
  'filter.operator.not_equals': 'n\'est pas égal à',
  'filter.operator.contains': 'contient',
  'filter.operator.not_contains': 'ne contient pas',
  'filter.operator.starts_with': 'commence par',
  'filter.operator.ends_with': 'se termine par',
  'filter.operator.gt': 'supérieur à',
  'filter.operator.lt': 'inférieur à',
  'filter.operator.gte': 'au moins',
  'filter.operator.lte': 'au plus',
  'filter.operator.between': 'entre',
  'filter.operator.in': 'fait partie de',
  'filter.operator.not_in': 'ne fait pas partie de',
  'filter.operator.is_set': 'est défini',
  'filter.operator.is_not_set': 'n\'est pas défini',
  'filter.placeholder.value': 'Valeur',
  'filter.placeholder.min': 'Min',
  'filter.placeholder.max': 'Max',
  'filter.placeholder.select': 'Sélectionner…',
  'filter.placeholder.selectMultiple': 'Sélectionner des valeurs…',
  'filter.logic.and': 'ET',
  'filter.logic.or': 'OU',

  // Documents
  
  // Validation

  // Toasts

  // Reviewer Dashboard

  // Account / Settings
  'settings.title': 'Paramètres du compte',

  // Consent
  'consent.title': 'Consentement',
  'consent.label': 'J\'accepte les conditions et la politique de commande',
  'consent.description': 'J\'ai lu et j\'accepte les conditions.',
  'consent.required': 'Veuillez accepter les conditions.',
  'consent.link.terms': 'Conditions',

  // Contacts
  'contacts.title': 'Contacts',
  'contacts.role': 'Rôle',
  'contacts.role.admin': 'Administrateur',
  'contacts.role.billing': 'Facturation',
  'contacts.role.technical': 'Technique',
  'contacts.role.other': 'Autre',

  // ARIA / Accessibility

  // Auth
  'auth.callback.title': 'Authentification',

  // Debug

  // Deliveries

  // SKU Mappings

  // PO List

  // PO Sprints

  // Terms page


  // Common UI Elements

  // Dashboard

  // AI Command Center

  // Learning & Development
  'learning.feed.greeting': 'Bonjour {{name}} !',
  'learning.feed.levelInfo': 'Niveau {{level}} • {{xp}} XP',
  'learning.feed.offline': 'Hors ligne',
  'learning.feed.streakLabel': 'Jours de série',
  'learning.feed.dailyGoal': 'Objectif quotidien',
  'learning.feed.recommendedLessons': 'Leçons recommandées',
  'learning.feed.priority.high': 'Haute',
  'learning.feed.priority.medium': 'Moyenne',
  'learning.feed.priority.low': 'Basse',
  'learning.feed.difficulty.easy': 'Facile',
  'learning.feed.difficulty.medium': 'Moyen',
  'learning.feed.difficulty.hard': 'Difficile',
  'learning.feed.aiRecommendation': 'Recommandation IA',
  'learning.feed.actions.start': 'Démarrer',
  'learning.feed.actions.skip': 'Passer',
  'learning.feed.actions.reload': 'Recharger',
  'learning.feed.empty.title': 'Toutes les leçons terminées !',

  // Helpdesk / Tickets
  'learning.feed.empty.description': 'Vous avez terminé toutes les leçons disponibles pour aujourd\'hui. Revenez demain !',
  'learning.quiz.title': 'Quiz',
  'learning.quiz.questionCounter': 'Question {{current}} sur {{total}}',
  'learning.quiz.options.true': 'Vrai',
  'learning.quiz.options.false': 'Faux',
  'learning.quiz.actions.next': 'Suivant',
  'learning.quiz.actions.finish': 'Terminer',
  'learning.quiz.actions.retry': 'Réessayer',
  'learning.quiz.badge.xp': '{{xp}} XP',
  'learning.quiz.badge.time': '{{seconds}}s',
  'learning.quiz.result.passedTitle': 'Quiz réussi !',
  'learning.quiz.result.failedTitle': 'Quiz échoué',
  'learning.quiz.result.scoreSummary': '{{correct}} sur {{total}} correct(s)',
  'learning.quiz.result.xpEarned': '+{{xp}} XP gagnés',
  'learning.quiz.result.answersHeading': 'Réponses détaillées',
  'learning.quiz.result.questionLabel': 'Question {{index}}',
  'learning.quiz.result.yourAnswer': 'Votre réponse',
  'learning.quiz.result.correctAnswer': 'Bonne réponse',
  'learning.lessonCard.difficulty.easy': 'Facile',
  'learning.lessonCard.difficulty.medium': 'Moyen',
  'learning.lessonCard.difficulty.hard': 'Difficile',
  'learning.lessonCard.status.completed': 'Terminé',
  'learning.lessonCard.reward': 'Récompense',
  'learning.lessonCard.progress': 'Progression',
  'learning.lessonCard.selectFormat': 'Choisir le format',
  'learning.lessonCard.prerequisites': 'Prérequis',
  'learning.lessonCard.actions.start': 'Démarrer',
  'learning.lessonCard.actions.repeat': 'Répéter',
  'learning.lessonCard.actions.pause': 'Pause',
  'learning.lessonCard.actions.complete': 'Terminer',
  'learning.lessonCard.actions.bookmark': 'Ajouter aux favoris',
  'learning.lessonCard.actions.unbookmark': 'Retirer des favoris',
  'learning.lessonCard.actions.collapse': 'Réduire',
  'learning.lessonCard.actions.expand': 'Développer',
  'learning.lessonCard.goalLabel': 'Objectif',
  'learning.lessonCard.formats.video': 'Regarder la vidéo',
  'learning.lessonCard.formats.text': 'Lire le texte',
  'learning.lessonCard.formats.audio': 'Écouter l\'audio',
  'learning.lessonCard.formats.cheatSheet': 'Aide-mémoire',
  'learning.lessonCard.formatUnknown': 'Inconnu',
  'learning.accessible.title': 'Tableau de bord de formation',
  'learning.accessible.welcome': 'Bon retour, {{name}}',
  'learning.accessible.voice.start': 'Voix',
  'learning.accessible.voice.stop': 'Arrêter l\'écoute',
  'learning.accessible.voice.listening': 'Écoute en cours...',
  'learning.accessible.level': 'Niveau',
  'learning.accessible.xpToNext': '{{value}} XP avant le prochain niveau',
  'learning.accessible.streak': 'Série',
  'learning.accessible.days': '{{value}} jours',
  'learning.accessible.keepItUp': 'Continuez comme ça !',
  'learning.accessible.badges': 'Badges',
  'learning.accessible.achievementsEarned': 'Réalisations obtenues',
  'learning.accessible.tabs.overview': 'Aperçu',
  'learning.accessible.tabs.lessons': 'Leçons',
  'learning.accessible.tabs.progress': 'Progression',
  'learning.accessible.tabs.achievements': 'Réalisations',
  'learning.accessible.recentActivity': 'Activité récente',
  'learning.accessible.noRecentActivity': 'Aucune activité récente',
  'learning.accessible.start': 'Démarrer',
  'learning.accessible.learningProgress': 'Progression de la formation',
  'learning.accessible.overallProgress': 'Progression globale',
  'learning.accessible.achievements': 'Réalisations',
  'learning.accessible.startingLesson': 'Démarrage de la leçon {{id}}',
  'learning.accessible.difficulty.beginner': 'Débutant',
  'learning.accessible.difficulty.intermediate': 'Intermédiaire',
  'learning.accessible.difficulty.advanced': 'Avancé',

  // Gamification & XP Toast
  'gamification.xpToast.xpLabel': 'XP',
  'gamification.xpToast.streakProgress': 'Progression de la série',
  'gamification.xpToast.streakProgressValue': '{{current}} / {{target}}',
  'gamification.xpToast.source.lesson': 'Leçon',
  'gamification.xpToast.source.quiz': 'Quiz',
  'gamification.xpToast.source.streak': 'Série',
  'gamification.xpToast.source.badge': 'Badge',
  'gamification.xpToast.source.bonus': 'Bonus',
  'gamification.xpToast.levelUp.title': 'Niveau supérieur !',
  'gamification.xpToast.levelUp.description': 'Vous avez atteint le niveau {{level}} !',
  'gamification.xpToast.levelUp.xpEarned': '+{{xp}} XP gagnés',
  'gamification.xpToast.button.continue': 'Continuer',
  'gamification.xpToast.streakMilestone.title': 'Jalon de série !',
  'gamification.xpToast.streakMilestone.description': 'Série de {{count}} jours atteinte !',
  'gamification.xpToast.streakMilestone.bonus': '+{{xp}} XP bonus gagnés',
  'gamification.close': 'Fermer',

  // Base de connaissances
  'knowledgeBase.back': 'Retour',
  'knowledgeBase.article.view': 'Voir',
  'knowledgeBase.article.views': '{{count}} vues',
  'knowledgeBase.article.helpful': '{{count}} utile(s)',
  'knowledgeBase.article.notHelpful': '{{count}} pas utile(s)',
  'knowledgeBase.article.byAuthor': 'Par {{author}}',
  'knowledgeBase.header.title': 'Base de connaissances',
  'knowledgeBase.header.subtitle': 'Trouvez des réponses à vos questions',
  'knowledgeBase.actions.filter': 'Filtrer',
  'knowledgeBase.actions.sort': 'Trier',
  'knowledgeBase.search.placeholder': 'Rechercher dans la base de connaissances...',
  'knowledgeBase.tabs.all': 'Tous',
  'knowledgeBase.stats.popular': 'Articles les plus populaires',
  'knowledgeBase.stats.viewsCount': '{{count}} vues',
  'knowledgeBase.stats.helpful': 'Articles les plus utiles',
  'knowledgeBase.stats.ratingsCount': '{{count}} évaluations',
  'knowledgeBase.stats.total': 'Total articles',
  'knowledgeBase.stats.totalCount': '{{count}} articles',
  'knowledgeBase.empty.title': 'Aucun article trouvé',
  'knowledgeBase.empty.searching': 'Essayez d\'autres termes de recherche ou consultez les catégories.',
  'knowledgeBase.empty.default': 'Aucun article disponible dans cette catégorie pour le moment.',
  'knowledgeBase.difficulty.beginner': 'Débutant',
  'knowledgeBase.difficulty.intermediate': 'Intermédiaire',
  'knowledgeBase.difficulty.advanced': 'Expert',
  'knowledgeBase.categories.odoo-basics': 'Bases Odoo',
  'knowledgeBase.categories.crm': 'CRM et ventes',
  'knowledgeBase.categories.inventory': 'Stock et achats',
  'knowledgeBase.categories.accounting': 'Comptabilité',
  'knowledgeBase.categories.projects': 'Gestion de projet',
  'knowledgeBase.categories.troubleshooting': 'Dépannage',

  // Accounting

  // Curriculum Planning
  'curriculum.video': 'Vidéo',
  'curriculum.videoDescription': 'Enregistrement d\'écran ou vidéo pratique',
  'curriculum.cheatSheet': 'Aide-mémoire',
  'curriculum.cheatSheetDescription': 'Prêt à imprimer, codes QR',
  'curriculum.test': 'Test/Quiz',
  'curriculum.testDescription': 'Enquête Odoo, 10 questions, 80%',
  'curriculum.checklist': 'Liste de contrôle',
  'curriculum.checklistDescription': 'Tâches Odoo, cliquables',
  'curriculum.textLesson': 'Texte/Leçon',
  'curriculum.textLessonDescription': 'Leçon de cours Odoo',
  'curriculum.roleplay': 'Jeu de rôle',
  'curriculum.roleplayDescription': 'En direct avec le parrain/Benno',
  'curriculum.practice': 'Exercice pratique',
  'curriculum.practiceDescription': 'Réaliser chez le client',

  // UI Components
  // Common Actions

  // Purchase Onboarding (wizard)

  // SCOUT - Wochenplanung
  'scout.wochenplanung.title': 'Vue d\'ensemble hebdomadaire',
  'scout.wochenplanung.previousWeek': 'Semaine précédente',
  'scout.wochenplanung.nextWeek': 'Semaine suivante',
  'scout.wochenplanung.toast.appointmentAdded': 'Rendez-vous ajouté',
  'scout.wochenplanung.toast.appointmentAddedDesc': '{{title}} – {{day}}',
  'scout.wochenplanung.toast.appointmentUpdated': 'Rendez-vous mis à jour',
  'scout.wochenplanung.toast.appointmentUpdatedDesc': '{{title}} – {{day}}',
  'scout.wochenplanung.toast.appointmentDeleted': 'Rendez-vous supprimé',
  'scout.wochenplanung.toast.slotUpdated': 'Créneau mis à jour',
  'scout.wochenplanung.toast.slotUpdatedDesc': 'Mission résolue ou créneau supprimé.',
  'scout.wochenplanung.legend.completed': 'terminé',
  'scout.wochenplanung.legend.planned': 'planifié',
  'scout.wochenplanung.legend.partial': 'partiellement planifié',
  'scout.wochenplanung.legend.unplanned': 'à planifier',
  'scout.wochenplanung.legend.holiday': 'Férié / Congés',
  'scout.wochenplanung.dialog.deleteAppointment.title': 'Supprimer le rendez-vous',
  'scout.wochenplanung.dialog.deleteAppointment.description': 'Voulez-vous vraiment supprimer ce rendez-vous ? Cette action est irréversible.',
  'scout.wochenplanung.dialog.editAppointment.title': 'Modifier le rendez-vous',
  'scout.wochenplanung.dialog.editAppointment.description': 'Voulez-vous appliquer les modifications à ce rendez-vous ?',
  'scout.wochenplanung.employee': 'Employé',
  'scout.wochenplanung.selectEmployee': 'Sélectionner un employé',
  'scout.wochenplanung.allEmployees': 'Tous les employés',
  'scout.wochenplanung.error.loading': 'Erreur lors du chargement de la planification hebdomadaire',
  'scout.wochenplanung.error.retry': 'Réessayer',

  // SCOUT - Mission list empty state & actions
  'scout.missionControl.tabs.team': 'Vue d\'équipe',
  'scout.missionControl.teamMembers': 'Membres de l\'équipe',
  'scout.missionControl.table.employee': 'Employé',
  'scout.missionControl.table.team': 'Équipe',
  'scout.missionControl.table.plzAreas': 'Zones code postal',

  // SCOUT - Mission Preferences

  // SCOUT - Missionen
  'scout.missionen.bestandskunden.loadError': 'Erreur lors du chargement des clients existants',
  'scout.missionen.bestandskunden.empty': 'Aucun client existant trouvé',
  'scout.missionen.bestandskunden.search': 'Rechercher des clients existants...',
  'scout.missionen.bestandskunden.filteredCount': '{{filtered}} sur {{total}} clients existants',
  'scout.missionen.wunschliste.industriesTitle': 'Branches préférées',
  'scout.missionen.wunschliste.productsTitle': 'Produits préférés',
  'scout.missionen.wunschliste.plzTitle': 'Régions code postal préférées',
  'scout.missionen.wunschliste.saveButton': 'Enregistrer',
  'scout.missionen.wunschliste.saved': 'Enregistré',
  'scout.missionen.wunschliste.savedDesc': 'Vos préférences ont été enregistrées.',
  'scout.missionen.wunschliste.saveError': 'Erreur',
  'scout.missionen.wunschliste.saveErrorDesc': 'Impossible d\'enregistrer les préférences.',
  'scout.missionen.wunschliste.loadError': 'Erreur lors du chargement des préférences',
  'scout.tagesplanung.title': 'Planification quotidienne',
  'scout.tagesplanung.addressUnknown': 'Adresse inconnue',
  'scout.tagesplanung.routeMapLabel': 'Carte de l\'itinéraire',
  'scout.tagesplanung.routePlanning': 'Planification d\'itinéraire',
  'scout.tagesplanung.traffic': 'Trafic',
  'scout.tagesplanung.deferNotPossible': 'Report impossible',
  'scout.tagesplanung.deferMaxReached': 'Nombre maximum de reports pour aujourd\'hui atteint (3/3).',
  'scout.tagesplanung.deferAlreadyDeferred': 'Ce prospect a déjà été reporté aujourd\'hui.',
  'scout.tagesplanung.dayCannotClose': 'Impossible de clôturer la journée',
  'scout.tagesplanung.outstandingReports': 'Il reste {{count}} rapport(s) de visite à compléter. Veuillez tous les remplir avant de clôturer la journée.',
  'scout.tagesplanung.andMore': '... et {{count}} autre(s)',
  'scout.tagesplanung.tabs.planning': 'Plan du jour',
  'scout.tagesplanung.tasks.tabLabel': 'Tâches',
  'scout.tagesplanung.tasks.empty': 'Aucune tâche',
  'scout.tagesplanung.tasks.loading': 'Chargement des tâches',
  'scout.tagesplanung.tasks.error': 'Impossible de charger les tâches',
  'scout.tagesplanung.tasks.filterFieldStatus': 'Statut',
  'scout.tagesplanung.tasks.filterStatusTodo': 'À faire',
  'scout.tagesplanung.tasks.filterStatusInProgress': 'En cours',
  'scout.tagesplanung.tasks.filterStatusDone': 'Terminé',
  'scout.tagesplanung.tasks.priorityLabel': 'Priorité',
  'scout.tagesplanung.tasks.priorityValue': '{{value}}',
  'scout.tagesplanung.tasks.priorityUnknown': '—',
  'scout.tagesplanung.tasks.dueLabel': 'Échéance',
  'scout.tagesplanung.tasks.dueNone': 'Pas d’échéance',
  'scout.lead.neukunde': 'Nouveau client — produit de niche comme ouverture',
  'scout.lead.bestandskunde': 'Client existant',
  'scout.metrics.besuche': 'Visites',
  'scout.metrics.demos': 'Démos',
  'scout.metrics.auftraege': 'Commandes',
  'scout.metrics.umsatz': 'Chiffre d\'affaires',
  'scout.metrics.demoRate': 'Taux de démo',
  'scout.composition.title': 'Composition de la mission',
  'scout.composition.minBestandskunden': 'Min. clients existants',
  'scout.composition.minQualifiziert': 'Min. prospects qualifiés',
  'scout.composition.maxKaltbesuche': 'Max. visites à froid',

  // Scout daily planning
  'scout.dailyPlanning.addAppointment': 'Ajouter un rendez-vous',
  'scout.dailyPlanning.appointments': 'Rendez-vous',
  'scout.dailyPlanning.noAppointmentsPlanned': 'Aucun rendez-vous prévu pour ce jour',
  'scout.dailyPlanning.leadsByPriority': 'Prospects (par priorité)',
  'scout.dailyPlanning.noLeadsPlanned': 'Aucun prospect prévu pour ce jour',
  'scout.dailyPlanning.skipLead': 'Passer le prospect',
  'scout.dailyPlanning.skipLeadConfirmation': 'Voulez-vous vraiment passer ce prospect ? Il sera déplacé au jour suivant.',
  'scout.dailyPlanning.skip': 'Passer',
  'scout.dailyPlanning.removeLead': 'Retirer le prospect',
  'scout.dailyPlanning.removeLeadConfirmation': 'Voulez-vous vraiment retirer ce prospect ? Il sera complètement retiré de la rotation.',
  'scout.dailyPlanning.selectMissionToViewLeads': 'Sélectionnez une mission pour afficher les prospects',
  'scout.dailyPlanning.selectDate': 'Sélectionner la date',
  'scout.dailyPlanning.nextDay': 'Jour suivant',
  'scout.dailyPlanning.closeDay': 'Clôturer la journée',
  'scout.dailyPlanning.reopenDay': 'Rouvrir la journée',
  'scout.dailyPlanning.noAcceptedLeads': 'Aucun prospect accepté pour ce jour.',
  'scout.dailyPlanning.statusSkipped': 'Passé',
  'scout.dailyPlanning.selectAll': 'Tout sélectionner',
  'scout.dailyPlanning.selectAllLeads': 'Sélectionner tous les prospects',
  'scout.dailyPlanning.noSuggestions': 'Aucune suggestion.',
  'scout.dailyPlanning.previousDay': 'Jour précédent',
  'scout.dailyPlanning.calendarWeek': 'Semaine {{weekNumber}}',
  'scout.dailyPlanning.visit': 'Visite',
  'scout.dailyPlanning.details': 'Détails',
  'scout.dailyPlanning.missionsLoading': 'Chargement des missions…',
  'scout.dailyPlanning.leadsLoading': 'Chargement des prospects…',
  'scout.dailyPlanning.noLeadsFound': 'Aucun prospect trouvé',
  'scout.dailyPlanning.moreLeads': 'de plus',
  'scout.dailyPlanning.dailyList': 'Liste du jour',
  'scout.dailyPlanning.unknown': 'Inconnu',
  'scout.dailyPlanning.suggestedLeads': 'Prospects suggérés',
  'scout.dailyPlanning.error': 'Erreur : {{error}}',
  'scout.dailyPlanning.help': 'Aide',
  'scout.dailyPlanning.bulkActions': 'Actions groupées',
  'scout.dailyPlanning.actionsCount': 'Actions ({{count}})',
  'scout.dailyPlanning.accept': 'Accepter',
  'scout.dailyPlanning.reject': 'Refuser',
  'scout.dailyPlanning.selectLead': 'Sélectionner le prospect {{name}}',
  'scout.dailyPlanning.openLeadDetails': 'Ouvrir les détails de {{name}}',
  'scout.dailyPlanning.score': 'Score : {{score}}',
  'scout.dailyPlanning.loading': 'Chargement de la planification quotidienne',

  // Scout weekly planning
  // Scout scorecard
  'scout.scorecard.selectHeatmapMetric': 'Sélectionner la métrique pour la heatmap',
  'scout.scorecard.orders': 'Commandes',
  'scout.scorecard.annualTargetOrders': 'Objectif annuel de commandes',
  'scout.scorecard.comingSoon': 'Bientôt disponible',
  'scout.scorecard.kpiOverview': 'Vue d\'ensemble KPI, activités et principaux secteurs',
  'scout.scorecard.activityByDay': 'Activité par jour',
  'scout.scorecard.title': 'Tableau de bord',
  'scout.scorecard.period.tag': 'Jour',
  'scout.scorecard.period.woche': 'Semaine',
  'scout.scorecard.period.monat': 'Mois',
  'scout.scorecard.period.jahr': 'Année',
  'scout.scorecard.kpiTilesHeading': 'KPI',
  'scout.scorecard.topBranchenProdukteHeading': 'Top secteurs et top produits',
  'scout.scorecard.soll': 'Objectif',
  'scout.scorecard.forecast': 'Prévision',
  'scout.scorecard.gapToGo': 'Reste à faire',
  'scout.scorecard.csvExport': 'Export CSV',
  'scout.scorecard.pdfExport': 'Export PDF',
  'scout.scorecard.table.date': 'Date',
  'scout.scorecard.table.visits': 'Visites',
  'scout.scorecard.table.demos': 'Démos',
  'scout.scorecard.table.orders': 'Commandes',
  'scout.scorecard.table.60l': '60L',
  'scout.scorecard.table.25l': '25L',
  'scout.scorecard.table.10l': '10L',
  'scout.scorecard.table.netRevenue': 'Chiffre d\'affaires net',
  'scout.scorecard.table.total': 'Total',
  'scout.scorecard.topBranchen': 'Top secteurs',
  'scout.scorecard.topProdukte': 'Top produits',
  'scout.scorecard.table.industry': 'Secteur',
  'scout.scorecard.table.quantity': 'Quantité (unités)',
  'scout.scorecard.table.revenue': 'Chiffre d\'affaires (€)',
  'scout.scorecard.table.product': 'Produit',
  'scout.scorecard.table.salesVolume': 'Volume des ventes',
  'scout.scorecard.table.customers': 'Clients',
  'scout.scorecard.kpi.visits': 'Visites',
  'scout.scorecard.kpi.demos': 'Démos',
  'scout.scorecard.kpi.orders': 'Commandes',
  'scout.scorecard.kpi.netRevenue': 'Chiffre d\'affaires net',
  'scout.scorecard.kpi.gebinde60l': 'Unité 60L',
  'scout.scorecard.kpi.gebinde25l': 'Unité 25L',
  'scout.scorecard.kpi.gebinde10l': 'Unité 10L',
  'scout.scorecard.emptyTitle': 'Aucune donnée',
  'scout.scorecard.emptyDescription': 'Aucune donnée KPI pour la période sélectionnée.',
  'scout.scorecard.missionPerformanceTitle': 'Performance des missions',
  'scout.scorecard.missionMissionsCompleted': 'Missions terminées',
  'scout.scorecard.missionConversionRate': 'Taux de conversion',
  'scout.scorecard.missionTerritoryCoverage': 'Couverture du territoire',
  'scout.scorecard.viewMissionDetails': 'Voir les détails',
  'scout.scorecard.adjustTargets': 'Ajuster les objectifs',
  'scout.scorecard.annualTarget': 'Objectif annuel',
  'scout.scorecard.annualTargetVisits': 'Objectif annuel de visites',
  'scout.scorecard.annualTargetDemos': 'Objectif annuel de démos',
  'scout.scorecard.annualTargetNetRevenue': 'Chiffre d\'affaires net (€)',
  'scout.scorecard.annualTargetNetRevenueA11y': 'Objectif annuel chiffre d\'affaires net en euros',
  'scout.scorecard.monthlyOverrides': 'Ajustements mensuels',
  'scout.scorecard.table.month': 'Mois',
  'scout.scorecard.table.reason': 'Motif',
  'scout.scorecard.derivedTargets': 'Objectifs dérivés',
  'scout.scorecard.dailyTargetLabel': 'Objectif du jour : {{count}} visites',
  'scout.scorecard.weeklyTargetLabel': 'Objectif de la semaine : {{count}} visites',
  'scout.scorecard.save': 'Enregistrer',
  'scout.scorecard.heatmap.visits': 'Visites',
  'scout.scorecard.heatmap.demos': 'Démos',
  'scout.scorecard.heatmap.revenue': 'Chiffre d\'affaires',
  'scout.scorecard.heatmap.low': 'Faible',
  'scout.scorecard.heatmap.high': 'Élevé',
  'scout.scorecard.heatmap.scaleA11y': 'Échelle de couleur de faible à élevé',
  'scout.scorecard.heatmap.loading': 'Chargement de la carte…',
  // Scout mission control
  'scout.missionControl.teamOverview': 'Votre équipe et leurs zones de code postal',
  'scout.missionControl.jokerLimitPerDay': 'Limite joker / jour',
  'scout.missionControl.jokerLimitUpdated': 'Limite joker mise à jour.',
  'scout.missionControl.jokerLimitSaveFailed': 'Impossible d\'enregistrer la limite joker.',
  'scout.missionControl.selectTeam': 'Sélectionner l\'équipe',
  'scout.missionControl.none': 'Aucun',
  'scout.missionControl.addPlzAreaFor': 'Ajouter une zone de code postal pour',
  'scout.missionControl.addPlzArea': 'Ajouter une zone de code postal',
  'scout.missionControl.noTeamMembersFound': 'Aucun membre d\'équipe trouvé.',
  'scout.missionControl.orders': 'Commandes',
  'scout.missionControl.resetSettings': 'Réinitialiser les paramètres',
  'scout.missionControl.saveSettings': 'Enregistrer les paramètres',
  'scout.missionControl.territorySaturation': 'Saturation du territoire (code postal)',
  'scout.missionControl.day': 'Jour',
  'scout.missionControl.selectDay': 'Sélectionner le jour',
  'scout.missionControl.week': 'Semaine',
  'scout.missionControl.selectWeek': 'Sélectionner la semaine',
  'scout.missionControl.month': 'Mois',
  'scout.missionControl.selectMonth': 'Sélectionner le mois',
  'scout.missionControl.planFulfillment': 'Réalisation du plan',
  'scout.missionControl.plzPrefixPlaceholder': 'Préfixe code postal (ex. 70)',
  'scout.missionControl.plzPrefix': 'Préfixe code postal',
  'scout.missionControl.addPlzToWhitelist': 'Ajouter le préfixe à la liste blanche',
  'scout.missionControl.addPlzToGreylist': 'Ajouter le préfixe à la liste grise',
  'scout.missionControl.addPlzToYellowlist': 'Ajouter le préfixe à la liste jaune',
  'scout.missionControl.addNewTeamMember': 'Ajouter un membre à l\'équipe',
  'scout.missionControl.lastModified': 'Dernière modification',
  'scout.missionControl.outsideAreaRules': 'Règles hors zone',
  'scout.missionControl.outsidePlzPolicy': 'Règle pour les codes postaux hors listes',
  'scout.missionControl.enableOutsideWarning': 'Activer l\'avertissement pour code postal hors zone',
  'scout.missionControl.requireOutsideApproval': 'Approbation requise pour code postal hors zone',
  'scout.missionControl.rejectOutsidePlz': 'Rejeter les codes postaux hors zone',
  'scout.missionControl.checkPlz': 'Vérifier le code postal ou le préfixe',
  'scout.missionControl.check': 'Vérifier',
  'scout.missionControl.error': 'Erreur',
  'scout.missionControl.success': 'Succès',
  'scout.missionControl.userProfileNotFound': 'Profil utilisateur introuvable',
  'scout.missionControl.plzAreasUpdated': 'Zones de code postal mises à jour',
  'scout.missionControl.plzAreasSaveFailed': 'Impossible d\'enregistrer les zones de code postal',

  // Mission Control → Config → KPI Target Configuration (MC-004)

  // Scout Mission Control — Rep Config (T13)
  'scout.missionControl.repConfig.title': 'Configuration des représentants',
  'scout.missionControl.repConfig.repName': 'Nom / E-mail',
  'scout.missionControl.repConfig.industries': 'Secteurs',
  'scout.missionControl.repConfig.products': 'Produits',
  'scout.missionControl.repConfig.plz': 'Code postal',
  'scout.missionControl.repConfig.loadError': 'Impossible de charger la configuration des représentants',
  'scout.missionControl.repConfig.saveError': 'Échec de l\'enregistrement',
  'scout.missionControl.repConfig.savedTitle': 'Enregistré',
  'scout.missionControl.repConfig.savedDesc': 'Configuration des représentants mise à jour',

  // Scout Mission Control — Joker Limit (T16)
  'scout.missionControl.jokerConfig.title': 'Limite joker par jour',
  'scout.missionControl.jokerConfig.description': 'Nombre maximum d\'utilisations du joker par représentant et par jour.',
  'scout.missionControl.jokerConfig.maxPerDay': 'Max. par jour',
  'scout.missionControl.jokerConfig.loadError': 'Impossible de charger la configuration joker',
  'scout.missionControl.jokerConfig.saveError': 'Échec de l\'enregistrement',
  'scout.missionControl.jokerConfig.savedTitle': 'Enregistré',
  'scout.missionControl.jokerConfig.savedDesc': 'Limite joker mise à jour',

  // Scout session (NAV-005)

  // Scout Mission Control — territories (MC-001, MC-002)

  // Scout Mission Control — diagnostics (MC-006)
  'scout.missionControl.diagnostics.demoRate': 'Taux de démo',
  'scout.missionControl.diagnostics.visitDepth': 'Profondeur de visite',

  // Scout Unternehmenssuche
  'scout.unternehmenssuche.selectAllResults': 'Sélectionner tous les résultats',
  'scout.unternehmenssuche.openingHours': 'HORAIRES D\'OUVERTURE',
  'scout.unternehmenssuche.temporarilyClosed': 'Temporairement fermé',
  'scout.unternehmenssuche.startSearch': 'Lancer la recherche',
  'scout.unternehmenssuche.searchRunning': 'Recherche en cours...',
  'scout.unternehmenssuche.adjustSearchCriteria': 'Veuillez modifier les critères ou réessayer.',
  'scout.unternehmenssuche.selectCompanyType': 'Sélectionner le type d\'entreprise',
  'scout.unternehmenssuche.openingHoursTime': 'Horaire d\'ouverture',
  'scout.unternehmenssuche.noTimeNeeded': 'Pas d\'horaire requis',
  'scout.unternehmenssuche.addConditions': 'Ajoutez des conditions pour affiner la recherche',
  'scout.unternehmenssuche.addCondition': 'Ajouter une condition',
  'scout.unternehmenssuche.addGroup': 'Ajouter un groupe',
  'scout.unternehmenssuche.savedSearchName': 'Nom de la recherche enregistrée',
  'scout.unternehmenssuche.saveCurrentSearch': 'Enregistrer la recherche actuelle',
  'scout.unternehmenssuche.savedSearches': 'Recherches enregistrées',
  'scout.unternehmenssuche.noSavedSearches': 'Aucune recherche enregistrée.',
  'scout.unternehmenssuche.keywordPlaceholder': 'ex. Restaurant, Bar, Boulangerie',
  'scout.unternehmenssuche.addWaypoint': 'Ajouter une étape',
  'scout.unternehmenssuche.locationPlaceholder': 'ex. Paris Place de la Concorde',
  'scout.unternehmenssuche.toggleAdditionalFilters': 'Afficher ou masquer les filtres supplémentaires',
  'scout.unternehmenssuche.additionalFilters': 'Filtres supplémentaires',
  'scout.unternehmenssuche.saveSearchAsFile': 'Enregistrer la recherche en fichier',
  'scout.unternehmenssuche.loadSearchFromFile': 'Charger une recherche depuis un fichier',
  'scout.unternehmenssuche.checkSearchTerms': 'Veuillez vérifier les termes ou réessayer.',

  // Search overlay
  'search.overlay.hint': 'Tapez et appuyez sur Entrée ou cliquez sur Rechercher.',
  'search.overlay.placeholder': 'Rechercher (/) ressources, docs et plus',
  'search.overlay.searchLabel': 'Rechercher',
  'search.overlay.noResults': 'Aucun résultat pour « {{query}} »',
  'search.overlay.tryDifferent': 'Essayez d\'autres termes ou vérifiez l\'orthographe.',
  'search.overlay.topResults': 'Meilleurs résultats',
  'search.overlay.documentation': 'Documentation · ',

  // Location/Route toggle (Unternehmenssuche)
  'scout.unternehmenssuche.locationRadius': 'Lieu + rayon',
  'scout.unternehmenssuche.routeCorridor': 'Itinéraire + couloir',
  'scout.unternehmenssuche.withoutLocation': 'Sans lieu',

  // Scout missions (Wave 3 i18n)
  'scout.scorecard.heatmapTitle': 'Heatmap d\'activité (code postal-2)',
  'scout.preferences.defaultRegionLabel': 'Région par défaut',
  'scout.preferences.selectRegionPlaceholder': 'Sélectionner la région',
  'scout.preferences.defaultStatusLabel': 'Statut par défaut',
  'scout.preferences.selectDefaultStatus': 'Sélectionner le statut par défaut',
  'scout.preferences.statusDraft': 'Brouillon',
  'scout.preferences.statusActive': 'Actif',
  'scout.preferences.statusCompleted': 'Terminé',
  'scout.preferences.statusArchived': 'Archivé',
  'scout.preferences.saving': 'Enregistrement...',
  'scout.preferences.plzPrefixes': 'Préfixes code postal pour les missions',
  'scout.preferences.plzPrefixesPlaceholder': 'Saisissez les préfixes séparés par des virgules (ex. 70, 71, 72)',
  'scout.preferences.maxRouteLength': 'Longueur max. de l\'itinéraire (km)',
  'scout.preferences.maxRouteLengthDescription': 'Longueur maximale de l\'itinéraire en kilomètres',
  'scout.preferences.autoGenerateMissions': 'Générer les missions automatiquement (automatisation nocturne)',
  'scout.preferences.autoGenerateDescription': 'Si activé, les missions sont générées automatiquement selon vos paramètres.',
  'scout.preferences.defaultAssigneeLabel': 'Responsable par défaut',
  'scout.preferences.defaultAssigneePlaceholder': 'Saisir le responsable par défaut',
  'scout.preferences.defaultAssigneeAria': 'Responsable par défaut',
  'scout.preferences.defaultLeadCountLabel': 'Nombre de prospects par défaut',
  'scout.preferences.defaultLeadCountAria': 'Nombre de prospects par défaut',
  'scout.preferences.defaultDurationLabel': 'Durée par défaut (jours)',
  'scout.preferences.defaultDurationAria': 'Durée par défaut en jours',
  'scout.preferences.autoAssignLabel': 'Assigner automatiquement les missions au responsable par défaut',
  'scout.preferences.productFamiliesLabel': 'Familles de produits',
  'scout.preferences.industryCodesLabel': 'Secteurs',
  'scout.preferences.keywordsLabel': 'Mots-clés',
  'scout.preferences.keywordsPlaceholder': 'ex. béton, chape',
  'scout.preferences.minLeadsLabel': 'Min. prospects par mission',
  'scout.preferences.minLeadsAria': 'Minimum de prospects par mission',
  'scout.preferences.maxLeadsLabel': 'Max. prospects par mission',
  'scout.preferences.maxLeadsAria': 'Maximum de prospects par mission',
  'scout.preferences.dailyQuotaLabel': 'Nombre de missions par jour',
  'scout.preferences.dailyQuotaAria': 'Nombre maximum de missions par jour',
  'scout.preferences.dailyQuotaHelper': 'Nombre maximum de missions générées automatiquement par jour (1-3)',
  'scout.dailyPlanning.inField': 'Sur le terrain',
  'scout.dailyPlanning.completed': 'Terminé',
  'scout.dailyPlanning.openDay': 'Ouvrir la journée',
  'scout.dailyPlanning.dayMarkedCompleted': 'Ce jour est marqué comme terminé.',
  'scout.dailyPlanning.statusVisited': 'Visité',
  'scout.dailyPlanning.statusPlanned': 'Planifié',
  'scout.dailyPlanning.statusCompleted': 'Terminé',
  'scout.createMission.title': 'Créer une nouvelle mission',
  'scout.createMission.description': 'Choisir le nom, les filtres et les assignations',
  'scout.createMission.nameLabel': 'Nom',
  'scout.createMission.nameRequired': 'Le nom est obligatoire',
  'scout.createMission.namePlaceholder': 'ex. Stuttgart Nord — Systèmes de froid',
  'scout.createMission.nameAria': 'Nom de la mission',
  'scout.createMission.regionLabel': 'Région (optionnel)',
  'scout.createMission.regionPlaceholder': 'ex. Code postal 70xxx',
  'scout.createMission.regionAria': 'Région ou code postal',
  'scout.createMission.ownerLabel': 'Responsable',
  'scout.createMission.ownerPlaceholder': 'Adresse e-mail',
  'scout.createMission.ownerAria': 'Adresse e-mail du responsable',
  'scout.createMission.themeLabel': 'Thème (optionnel)',
  'scout.createMission.themePlaceholder': 'ex. Systèmes de froid',
  'scout.createMission.themeAria': 'Thème de la mission',
  'scout.createMission.productLabel': 'Produit (optionnel)',
  'scout.createMission.productPlaceholder': 'ex. K-2000',
  'scout.createMission.productAria': 'Produit',
  'scout.createMission.cancel': 'Annuler',
  'scout.createMission.save': 'Enregistrer',
  'scout.createMission.saveBusy': 'Enregistrement…',
  'scout.createMission.cancelAria': 'Annuler la création de la mission',
  'scout.createMission.saveAria': 'Enregistrer la mission',
  'scout.createMission.saveBusyAria': 'Mission en cours d\'enregistrement',

  // Inventory

  // Sales

  // Purchase


  // Settings (from de.ts 1457+)
  'settings.description': 'Gérer les paramètres et les options de personnalisation de l\'application',
  'settings.typography.title': 'Typographie',
  'settings.typography.description': 'Ajuster la taille et la densité du texte pour une meilleure lisibilité',
  'settings.typography.scale.title': 'Taille du texte',
  'settings.typography.scale.description': 'Standard correspond à la base ; Confort agrandit la police pour les longues sessions',
  'settings.typography.scale.ariaLabel': 'Préréglage de taille du texte',
  'settings.typography.scale.compact': 'Compact',
  'settings.typography.scale.standard': 'Standard',
  'settings.typography.scale.comfort': 'Confort',
  'settings.tabs.appearance': 'Apparence',
  'settings.tabs.account': 'Compte',
  'settings.tabs.notifications': 'Notifications',
  'settings.tabs.security': 'Sécurité',
  'settings.language.title': 'Paramètres de langue',
  'settings.language.description': 'Choisissez la langue de l\'interface',
  'settings.language.interfaceLanguage': 'Langue de l\'interface',
  'settings.language.interfaceLanguageDesc': 'Langue des menus, boutons et éléments',
  'settings.theme.title': 'Thème de couleurs',
  'settings.theme.description': 'Personnaliser l\'apparence et les couleurs',
  'settings.theme.predefinedThemes': 'Choisir parmi 10 thèmes prédéfinis ?',
  'settings.theme.goToThemeSettings': 'Aller aux paramètres de thème',
  'settings.themeSettings.title': 'Paramètres de thème',
  'settings.themeSettings.description': 'Personnaliser l\'apparence avec des thèmes prédéfinis',
  'settings.themeSettings.themeDetails': 'Détails du thème',
  'settings.themeSettings.themeId': 'ID du thème :',
  'settings.themeSettings.colorScheme': 'Schéma de couleurs :',
  'settings.account.profile.title': 'Informations du profil',
  'settings.account.profile.description': 'Mettre à jour vos informations personnelles',
  'settings.account.profile.name': 'Nom',
  'settings.account.profile.email': 'E-mail',
  'settings.account.profile.role': 'Rôle',
  'settings.account.profile.department': 'Département',
  'settings.account.profile.editProfile': 'Modifier le profil',
  'settings.account.data.title': 'Gestion des données',
  'settings.account.data.description': 'Gérer la synchronisation et les sauvegardes',
  'settings.account.data.cloudSync': 'Synchronisation cloud',
  'settings.account.data.cloudSyncEnabled': 'Vos paramètres sont synchronisés dans le cloud',
  'settings.account.data.cloudSyncDisabled': 'Synchronisation cloud désactivée',
  'settings.account.data.syncNow': 'Synchroniser maintenant',
  'settings.notifications.title': 'Paramètres de notifications',
  'settings.notifications.description': 'Configurer la réception des notifications',
  'settings.notifications.email.title': 'Notifications par e-mail',
  'settings.notifications.email.description': 'Recevoir les notifications par e-mail',
  'settings.notifications.push.title': 'Notifications push',
  'settings.notifications.push.description': 'Recevoir les notifications push dans le navigateur',
  'settings.notifications.system.title': 'Alertes système',
  'settings.notifications.system.description': 'Notifications système importantes',
  'settings.notifications.configure': 'Configurer',
  'settings.security.title': 'Paramètres de sécurité',
  'settings.security.description': 'Gérer la sécurité et la confidentialité du compte',
  'settings.security.password.title': 'Mot de passe',
  'settings.security.password.lastChanged': 'Modifié il y a 30 jours',
  'settings.security.password.change': 'Modifier',
  'settings.security.twoFactor.title': 'Authentification à deux facteurs',
  'settings.security.twoFactor.description': 'Ajouter une couche de sécurité supplémentaire',
  'settings.security.twoFactor.enable': 'Activer',
  'settings.security.sessions.title': 'Gestion des sessions',
  'settings.security.sessions.description': 'Gérer les sessions actives',
  'settings.security.sessions.view': 'Voir les sessions',
  'settings.company.title': 'Paramètres de l\'entreprise',
  'settings.company.description': 'Gérer les informations et paramètres de l\'entreprise',
  'settings.company.edit': 'Modifier l\'entreprise',
  'settings.company.saveChanges': 'Enregistrer les modifications',
  'settings.company.cancel': 'Annuler',
  'settings.company.tabs.general': 'Général',
  'settings.company.tabs.contact': 'Contact',
  'settings.company.tabs.billing': 'Facturation',
  'settings.company.tabs.branding': 'Image de marque',
  'settings.company.general.companyInfo': 'Informations sur l\'entreprise',
  'settings.company.general.companyName': 'Nom de l\'entreprise',
  'settings.company.general.legalName': 'Raison sociale',
  'settings.company.general.taxId': 'Numéro fiscal',
  'settings.company.general.registrationNumber': 'Numéro d\'immatriculation',
  'settings.company.general.industry': 'Secteur',
  'settings.company.general.foundedYear': 'Année de création',
  'settings.company.general.employees': 'Nombre d\'employés',
  'settings.company.general.industry.technology': 'Technologie',
  'settings.company.general.industry.manufacturing': 'Production',
  'settings.company.general.industry.retail': 'Commerce de détail',
  'settings.company.general.industry.healthcare': 'Santé',
  'settings.company.general.industry.finance': 'Finance',
  'settings.company.general.industry.other': 'Autre',
  'settings.company.address.title': 'Adresse',
  'settings.company.address.street': 'Rue',
  'settings.company.address.city': 'Ville',
  'settings.company.address.state': 'Région',
  'settings.company.address.zipCode': 'Code postal',
  'settings.company.address.country': 'Pays',
  'settings.company.address.country.us': 'États-Unis',
  'settings.company.address.country.ca': 'Canada',
  'settings.company.address.country.uk': 'Royaume-Uni',
  'settings.company.address.country.de': 'Allemagne',
  'settings.company.address.country.fr': 'France',
  'settings.company.address.country.other': 'Autre',
  'settings.company.contact.title': 'Contact',
  'settings.company.contact.phone': 'Téléphone',
  'settings.company.contact.email': 'E-mail',
  'settings.company.contact.website': 'Site web',
  'settings.company.contact.supportEmail': 'E-mail support',
  'settings.company.billing.title': 'Facturation',
  'settings.company.billing.currency': 'Devise',
  'settings.company.billing.taxRate': 'Taux de TVA (%)',
  'settings.company.billing.paymentTerms': 'Conditions de paiement',
  'settings.company.billing.billingCycle': 'Cycle de facturation',
  'settings.company.billing.paymentTerms.net15': 'Net 15',
  'settings.company.billing.paymentTerms.net30': 'Net 30',
  'settings.company.billing.paymentTerms.net45': 'Net 45',
  'settings.company.billing.paymentTerms.net60': 'Net 60',
  'settings.company.billing.paymentTerms.dueOnReceipt': 'À réception',
  'settings.company.billing.cycle.monthly': 'Mensuel',
  'settings.company.billing.cycle.quarterly': 'Trimestriel',
  'settings.company.billing.cycle.annually': 'Annuel',
  'settings.company.billing.cycle.custom': 'Personnalisé',
  'settings.company.billing.summary.title': 'Résumé de facturation',
  'settings.company.billing.summary.currentPlan': 'Offre actuelle',
  'settings.company.billing.summary.monthlyCost': 'Coût mensuel',
  'settings.company.billing.summary.nextBillingDate': 'Prochaine facturation',
  'settings.company.billing.summary.paymentMethod': 'Mode de paiement',
  'settings.company.billing.summary.status': 'Statut',
  'settings.company.billing.summary.active': 'Actif',
  'settings.company.branding.title': 'Image de marque',
  'settings.company.branding.logo': 'Logo',
  'settings.company.branding.uploadLogo': 'Télécharger le logo',
  'settings.company.branding.logoHint': 'PNG, JPG jusqu\'à 2 Mo',
  'settings.company.branding.favicon': 'Favicon',
  'settings.company.branding.uploadFavicon': 'Télécharger le favicon',
  'settings.company.branding.faviconHint': 'ICO, PNG jusqu\'à 1 Mo',
  'settings.company.branding.primaryColor': 'Couleur primaire',
  'settings.company.branding.secondaryColor': 'Couleur secondaire',
  'settings.usersRoles.stats.totalUsers': 'Total utilisateurs',
  'settings.usersRoles.stats.activeUsers': 'utilisateurs actifs',
  'settings.usersRoles.stats.totalRoles': 'Total rôles',
  'settings.usersRoles.stats.roleConfigurations': 'configurations de rôles',
  'settings.userManagement.title': 'Gestion des utilisateurs',
  'settings.userManagement.description': 'Gérer les utilisateurs, rôles et paramètres système',
  'settings.userManagement.addUser': 'Ajouter un utilisateur',
  'settings.userManagement.editUser': 'Modifier l\'utilisateur',
  'settings.userManagement.createNewUser': 'Créer un utilisateur',
  'settings.userManagement.updateUserInfo': 'Mettre à jour les informations utilisateur',
  'settings.userManagement.addNewUser': 'Ajouter un nouvel utilisateur au système',
  'settings.userManagement.tabs.users': 'Utilisateurs',
  'settings.userManagement.tabs.appAccess': 'Accès aux applications',
  'settings.userManagement.tabs.roles': 'Rôles',
  'settings.userManagement.toast.userCreated': 'Utilisateur créé avec succès',
  'settings.userManagement.toast.userUpdated': 'Utilisateur mis à jour avec succès',
  'settings.userManagement.toast.userDeleted': 'Utilisateur supprimé avec succès',
  'settings.userManagement.toast.roleCreated': 'Rôle créé avec succès',
  'settings.userManagement.toast.roleUpdated': 'Rôle mis à jour avec succès',
  'settings.userManagement.toast.roleDeleted': 'Rôle supprimé avec succès',
  'settings.userManagement.toast.error': 'Impossible de créer l\'utilisateur',
  'settings.userManagement.toast.errorUpdate': 'Impossible de mettre à jour l\'utilisateur',
  'settings.userManagement.toast.errorDelete': 'Impossible de supprimer l\'utilisateur',
  'settings.userManagement.toast.errorRoleCreate': 'Impossible de créer le rôle',
  'settings.userManagement.toast.errorRoleUpdate': 'Impossible de mettre à jour le rôle',
  'settings.userManagement.toast.errorRoleDelete': 'Impossible de supprimer le rôle',
  'settings.integrations.settings.security.enabled': 'Activé',
  'settings.integrations.settings.security.disabled': 'Désactivé',

  // Analytics - Pivot Table

  // Reports

  // Warehouse - Picking

  // Warehouse - Returns

  // Warehouse - ASN

  // CRM - Contacts
  'crm.contacts.title': 'Contacts CRM',
  'crm.contacts.description': 'Gérer les contacts clients et fournisseurs avec adresses',
  'crm.contacts.add': 'Ajouter un contact',
  'crm.contacts.edit': 'Modifier le contact',
  'crm.contacts.delete': 'Supprimer le contact',
  'crm.contacts.view360': 'Vue 360°',
  'crm.contacts.unassigned': 'Non assigné',
  'crm.contacts.type.customer': 'Client',
  'crm.contacts.type.supplier': 'Fournisseur',
  'crm.contacts.type.partner': 'Partenaire',
  'crm.contacts.type.prospect': 'Prospect',
  'crm.contacts.status.active': 'Actif',
  'crm.contacts.status.inactive': 'Inactif',
  'crm.contacts.status.suspended': 'Suspendu',
  'crm.contacts.validation.companyRequired': 'Le nom de l\'entreprise est obligatoire',
  'crm.contacts.validation.streetRequired': 'L\'adresse est obligatoire',
  'crm.contacts.validation.postalRequired': 'Le code postal est obligatoire',
  'crm.contacts.validation.cityRequired': 'La ville est obligatoire',
  'crm.contacts.validation.countryRequired': 'Le pays est obligatoire',
  'crm.contacts.validation.nameRequired': 'Le nom du contact est obligatoire',
  'crm.contacts.validation.emailInvalid': 'Adresse e-mail invalide',
  'crm.contacts.validation.phoneRequired': 'Le téléphone est obligatoire',
  'crm.contacts.validation.salesPersonRequired': 'Le commercial est obligatoire',
  'crm.contacts.validation.ordererNameRequired': 'Le nom du commanditaire est obligatoire',
  'crm.contacts.validation.roleRequired': 'Le rôle est obligatoire',
  'crm.contacts.validation.hoursRequired': 'Les horaires sont obligatoires',
  'crm.openMenu': 'Ouvrir le menu',

  // CRM - Leads
  'crm.leads.title': 'Prospects',
  'crm.leads.description': 'Gérer les prospects et suivre la conversion',
  'crm.leads.add': 'Ajouter un prospect',
  'crm.leads.edit': 'Modifier le prospect',
  'crm.leads.delete': 'Supprimer le prospect',
  'crm.leads.status.new': 'Nouveau',
  'crm.leads.status.contacted': 'Contacté',
  'crm.leads.status.qualified': 'Qualifié',
  'crm.leads.status.proposal': 'Devis',
  'crm.leads.status.negotiation': 'Négociation',
  'crm.leads.status.closedWon': 'Gagné',
  'crm.leads.status.closedLost': 'Perdu',
  'crm.leads.source.website': 'Site web',
  'crm.leads.source.referral': 'Recommandation',
  'crm.leads.source.email': 'E-mail',
  'crm.leads.source.phone': 'Téléphone',
  'crm.leads.source.social': 'Réseaux sociaux',
  'crm.leads.source.other': 'Autre',
  'crm.leads.value': 'Valeur',
  'crm.leads.lastContact': 'Dernier contact',
  'crm.leads.notes': 'Notes',
  'crm.leads.search': 'Rechercher des prospects...',
  'crm.leads.filterByStatus': 'Filtrer par statut',
  'crm.leads.filterBySource': 'Filtrer par source',
  'crm.leads.totalLeads': 'Total prospects',
  'crm.leads.pipelineValue': 'Valeur du pipeline',
  'crm.leads.qualifiedLeads': 'Prospects qualifiés',

  // Visit Report
  'visitReport.title': 'Rapport de visite',
  'visitReport.createTitle': 'Créer un rapport de visite',
  'visitReport.titleFor': 'Rapport de visite pour {{name}}',
  'visitReport.visitType': 'Type de visite',
  'visitReport.coldVisit': 'Visite à froid',
  'visitReport.appointment': 'Rendez-vous',
  'visitReport.salesOutcome': 'Résultat commercial',
  'visitReport.noContact': 'Pas de contact',
  'visitReport.conversation': 'Conversation',
  'visitReport.demo': 'Démo',
  'visitReport.order': 'Commande',
  'visitReport.orderValue': 'Montant de la commande (EUR)',
  'visitReport.nextStep': 'Prochaine étape',
  'visitReport.callback': 'Rappel',
  'visitReport.sendOffer': 'Envoyer un devis',
  'visitReport.revisit': 'Revisite',
  'visitReport.completed': 'Terminé',
  'visitReport.appointmentWindow': 'Créneau (optionnel)',
  'visitReport.from': 'De',
  'visitReport.to': 'À',
  'visitReport.contactName': 'Nom du contact',
  'visitReport.enterName': 'Saisir le nom',
  'visitReport.roleFunction': 'Fonction / Rôle',
  'visitReport.enterRole': 'Saisir la fonction',
  'visitReport.isDecisionMaker': 'Est décideur ?',
  'visitReport.decisionMakerName': 'Nom du décideur',
  'visitReport.decisionMakerRole': 'Fonction du décideur',
  'visitReport.email': 'E-mail (optionnel)',
  'visitReport.phone': 'Téléphone (optionnel)',
  'visitReport.notes': 'Notes (optionnel)',
  'visitReport.additionalInfo': 'Informations complémentaires...',
  'visitReport.productsDiscussed': 'Produits présentés ?',
  'visitReport.annualDemand': 'Demande annuelle',
  'visitReport.select': 'Sélectionner',
  'visitReport.interest': 'Intérêt',
  'visitReport.interestHigh': 'élevé',
  'visitReport.interestMedium': 'moyen',
  'visitReport.interestLow': 'faible',
  'visitReport.modelFeedback': 'La recommandation du système était-elle adaptée ?',
  'visitReport.feedbackYes': 'Oui',
  'visitReport.feedbackPartially': 'Partiellement',
  'visitReport.feedbackNo': 'Non',
  'visitReport.feedbackNotSeen': 'Non vu',
  'visitReport.branchCorrect': 'Secteur correct ? (optionnel)',
  'visitReport.selectBranch': 'Sélectionner le secteur',
  'visitReport.branchConstruction': 'BTP',
  'visitReport.branchIndustry': 'Industrie',
  'visitReport.branchTrade': 'Commerce',
  'visitReport.branchService': 'Services',
  'visitReport.noInterestReason': 'Raison du manque d\'intérêt',
  'visitReport.wrongProduct': 'Mauvais produit',
  'visitReport.wrongTiming': 'Mauvais timing',
  'visitReport.existingSupplier': 'Fournisseur actuel',
  'visitReport.noBudget': 'Pas de budget',
  'visitReport.noNeed': 'Pas de besoin',
  'visitReport.decisionMakerNotReached': 'Décideur non joint',
  'visitReport.additionalRemarks': 'Remarques (optionnel)',
  'visitReport.error': 'Erreur',
  'visitReport.validationError': 'Veuillez sélectionner le type de visite et le résultat commercial.',
  'visitReport.deferralNotPossible': 'Report impossible',
  'visitReport.maxDeferralReached': 'Vous avez déjà reporté le dernier rapport. Veuillez le remplir.',
  'visitReport.reportDeferred': 'Rapport reporté',
  'visitReport.deferralMessage': 'Vous pourrez remplir le rapport plus tard.',
  'visitReport.reportCreated': 'Rapport de visite créé',
  'visitReport.reportSaved': 'Rapport de visite enregistré.',
  'visitReport.reportSavedFor': 'Rapport de visite pour {{name}} enregistré.',
  'visitReport.reportError': 'Impossible de créer le rapport de visite.',
  'visitReport.stepOf': 'Étape {{current}} sur {{total}}',
  'visitReport.back': 'Retour',
  'visitReport.cancel': 'Annuler',
  'visitReport.inAHurry': 'Je suis pressé',
  'visitReport.next': 'Suivant',
  'visitReport.saving': 'Enregistrement...',
  'visitReport.finishVisit': 'Clôturer la visite',
  'visitReport.contactNotes': 'Informations complémentaires sur le contact...',
  'visitReport.callingQueue.prompt': 'Préparer un appel IA pour prendre rendez-vous avec ce prospect ?',
  'visitReport.callingQueue.yes': 'Oui, mettre en file d\'attente',
  'visitReport.callingQueue.no': 'Non',
  'visitReport.callingQueue.toast': 'Prospect ajouté à la file d\'appels.',

  // --- SS-145: admin ---

  // --- SS-145: learning ---

  // --- SS-145: modals ---
  'modals.assignMissionModal.close': 'Fermer',
  'modals.assignMissionModal.searchPlaceholder': 'Rechercher (titre/secteur)',
  'modals.assignMissionModal.searchAriaLabel': 'Recherche',
  'modals.missionQuickViewModal.description': 'Aperçu rapide de la mission. Ouvrez la page mission pour les détails.',
  'modals.missionQuickViewModal.close': 'Fermer',
  'modals.missionQuickViewModal.openDetails': 'Ouvrir les détails',
  'modals.missionQuickViewModal.openDetailsAria': 'Ouvrir le détail de la mission',
  'modals.leadDetailModal.close': 'Fermer',
  'modals.leadDetailModal.whoIsThis': 'Qui est-ce ?',
  'modals.leadDetailModal.whatDoTheyNeed': 'De quoi ont-ils besoin ?',
  'modals.leadDetailModal.whatDoISay': 'Que dire ?',
  'modals.leadDetailModal.moreProducts': 'Plus de produits',
  'modals.regionDetailsModal.description': 'Aperçu des détails de la mission. Vue en lecture seule.',
  'modals.regionDetailsModal.edit': 'Modifier',
  'modals.regionDetailsModal.close': 'Fermer',
  'modals.editRegionModal.close': 'Fermer',
  'modals.editRegionModal.description': 'Modifier l\'heure et la note de la mission. Le statut est en lecture seule.',
  'modals.editRegionModal.statusReadonlySrOnly': 'Le statut est en lecture seule.',
  'modals.splitAssignmentDialog.actionLabel': 'Choisir l\'action',
  'modals.splitAssignmentDialog.confirmButton': 'Confirmer',
  'modals.addAppointmentModal.companyAriaLabel': 'Sélectionner ou saisir l\'entreprise / prospect',
  'modals.addAppointmentModal.commitmentConfirmed': 'Confirmé',
  'modals.rejectLead.title': 'Refuser le prospect',
  'modals.rejectLead.closeAria': 'Fermer le dialogue',
  'modals.rejectLead.description': 'Sélectionnez au moins un motif de refus.',
  'modals.rejectLead.reasonsLabel': 'Motifs de refus',
  'modals.rejectLead.reasonsError': 'Veuillez sélectionner au moins un motif.',
  'modals.rejectLead.otherReasonLabel': 'Autre motif',
  'modals.rejectLead.otherReasonPlaceholder': 'Veuillez décrire le motif...',
  'modals.rejectLead.otherReasonAria': 'Autre motif de refus',
  'modals.rejectLead.otherReasonError': 'Veuillez saisir un motif.',
  'modals.rejectLead.cancel': 'Annuler',
  'modals.rejectLead.confirm': 'Refuser ({count})',
  'modals.rejectLead.reason.outOfBusiness': 'Plus en activité',
  'modals.rejectLead.reason.temporarilyClosed': 'Temporairement fermé',
  'modals.rejectLead.reason.knownAndUnsuitable': 'Connu et non pertinent',
  'modals.rejectLead.reason.noInterest': 'Pas d\'intérêt',
  'modals.rejectLead.reason.wrongContact': 'Mauvais interlocuteur',
  'modals.rejectLead.reason.other': 'Autre',

  // --- SS-145: ui-components + app-components ---
  'app.routes.loadingSettings': 'Chargement des paramètres...',
  'companySearch.filters.companySize': 'Taille de l\'entreprise',
  'curriculum.modules.pillar': 'Pilier',
  'curriculum.modules.selectLevel': 'Sélectionner le niveau',
  'curriculum.modules.selectPillar': 'Sélectionner le pilier',
  'curriculum.modules.selectPillarOption': 'Sélectionner le pilier',
  'learning.lessonViewer.audioNotSupported': 'Votre navigateur ne prend pas en charge l\'audio.',
  'learning.lessonViewer.complete': 'Terminer',
  'learning.lessonViewer.formatNotSupported': 'Format non pris en charge',
  'learning.lessonViewer.videoNotSupported': 'Votre navigateur ne prend pas en charge la vidéo.',
  'learning.moduleEditor.pillar': 'Pilier',
  'learning.moduleEditor.pillarLabel': 'Pilier',
  'learning.tabs.availableLessons': 'Leçons disponibles',
  'learning.tabs.availableQuizzes': 'Quiz disponibles',
  'missions.management.demoPerformed': 'Démo réalisée',
  'missions.management.demoPerformedLabel': 'Démo réalisée',
  'missions.management.kpiDescription': 'Décideur rencontré, démo réalisée, chiffre d\'affaires',
  'missions.management.moreActions': 'Plus d\'actions pour la mission',
  'missions.management.publish': 'Publier',
  'missions.management.searchPlaceholder': 'Rechercher (nom/région/thème/produit)',
  'mobile.layout.closeMenu': 'Fermer le menu',
  'mobile.layout.menu': 'Menu',
  'mobile.layout.noOfflineContent': 'Aucun contenu hors ligne disponible',
  'mobile.layout.offlinePerformance': 'Pour de meilleures performances hors ligne',
  'navigation.tileCard.openActions': 'Ouvrir les actions de la tuile',
  'scout.preferences.badenWuerttemberg': 'Bade-Wurtemberg',
  'scout.preferences.thueringen': 'Thuringe',
  'scout.sprints.ciEstimate': 'Estimation du temps CI',
  'scout.sprints.estimatedMinutes': 'Minutes estimées',
  'styleGuide.charts.noStatusColors': 'Les graphiques ne doivent pas utiliser les couleurs de statut',
  'styleGuide.confirmation': 'Confirmation',
  'styleGuide.description': 'Description',
  'styleGuide.statusSemantics.success': 'Succès = Terminé / OK',
  'tickets.list.filterPriority': 'Filtrer par priorité',
  'ui.calendar.nextMonth': 'Mois suivant',
  'ui.errorBoundary.returnToDashboard': 'Retour au tableau de bord',
  'ui.impersonation.selectImpersonation': 'Sélectionner l\'usurpation',
  'ui.impersonation.selectUser': 'Sélectionner l\'utilisateur :',
  'ui.routingPreview.openAppleMaps': 'Ouvrir dans Apple Maps',
  'ui.routingPreview.openGoogleMaps': 'Ouvrir dans Google Maps',
  'ui.routingPreview.stopsLabel': '{{count}} étapes · {{distance}} km · {{time}} min (estimé)',
  'ui.routingPreview.title': 'Aperçu de l\'itinéraire',
  'weeklyPlanning.appointmentModal.additionalNotes': 'Notes supplémentaires',
  'weeklyPlanning.legacyAppointments.addAppointment': 'Ajouter un rendez-vous',
  'scout.help.selectArticle': 'Choisissez un article à gauche ou utilisez la recherche pour ouvrir un article d\'aide.',

  // Visit Report — Rejection Sheet (B1)

  // Visit Report — Post-Visit Report (B2)

  // Visit Report — Compliance Gate (B3)
  'scout.visitReport.compliance.title': 'Rapports de visite ouverts',
  'scout.visitReport.compliance.description': 'Vous avez {{count}} rapport(s) de visite ouvert(s). Veuillez les remplir d\'abord.',
  'scout.visitReport.compliance.lockoutTitle': 'Rapports requis',
  'scout.visitReport.compliance.lockoutDescription': 'Veuillez remplir tous les rapports de visite ouverts avant de continuer.',
  'scout.visitReport.compliance.deferButton': 'Remplir plus tard',
  'scout.visitReport.compliance.deferCount': '{{remaining}} report(s) restant(s)',
  'scout.visitReport.compliance.noDeferrals': 'Plus de reports disponibles',
  'scout.visitReport.compliance.fillReport': 'Remplir le rapport',
  'scout.visitReport.compliance.morningLockout': 'Planification quotidienne verrouillée jusqu\'à ce que tous les rapports ouverts soient remplis.',

  // Learning — Lehrplan & Curriculum (pages)
  'learning.lehrplan.title': 'Programme',
  'learning.lehrplan.subtitle': 'Gérer le programme et les objectifs d\'apprentissage',
  'learning.curriculumPlanning.title': 'Planification du programme',
  'learning.curriculumPlanning.subtitle': 'Structurer le programme et associer les contenus',

  // Navigation (App Overview, Tile View)
  'navigation.appOverview': 'Aperçu des applications',

  // PO Sprints (page titles)

  // Purchase (list/detail)

  // Sales (list)

  // Common (extra)
  'common.next': 'Suivant',

  // Warehouse Picking (action)

  // Scout Wochenplanung — Aggregates

  // Scout Mission Control — Plan View

  // CRM — Leads page (flat keys used in table/modal)
  'crm.leads': 'Prospects',
  'crm.closedWon': 'Affaires gagnées',
  'crm.searchPlaceholder': 'Rechercher des prospects...',
  'crm.name': 'Nom',
  'crm.company': 'Entreprise',
  'crm.contact': 'Contact',
  'crm.source': 'Source',
  'crm.value': 'Valeur',
  'crm.lastContact': 'Dernier contact',
  'crm.viewDetails': 'Voir les détails',
  'crm.editLead': 'Modifier le prospect',
  'crm.addNote': 'Ajouter une note',
  'crm.convertToCustomer': 'Convertir en client',
  'crm.deleteLead': 'Supprimer le prospect',
  'crm.leadDetails': 'Détails du prospect',
  'crm.addNewLead': 'Ajouter un prospect',
  'crm.viewLeadDetails': 'Voir les détails du prospect',
  'crm.createNewLead': 'Créer un prospect',
  'crm.fullName': 'Nom complet',
  'crm.email': 'E-mail',
  'crm.phone': 'Téléphone',
  'crm.estimatedValue': 'Valeur estimée',
  'crm.notes': 'Notes',
  'crm.status.new': 'Nouveau',
  'crm.status.contacted': 'Contacté',
  'crm.status.qualified': 'Qualifié',
  'crm.status.proposal': 'Devis',
  'crm.status.negotiation': 'Négociation',
  'crm.status.closedWon': 'Gagné',
  'crm.status.closedLost': 'Perdu',
  'crm.source.website': 'Site web',
  'crm.source.referral': 'Recommandation',
  'crm.source.tradeShow': 'Salon',
  'crm.source.coldCall': 'Prospection téléphonique',
  'crm.source.socialMedia': 'Réseaux sociaux',
  'crm.source.emailCampaign': 'Campagne e-mail',

  // Supplier onboarding — Form (CompanyInfoSection, ContactInfoSection, DocumentUploadSection)

  // Placeholders (supplier forms)

  // Form (supplier — ContactInfoSection)

  // Role (supplier contact)

  // Country (supplier address)
  'country.US': 'États-Unis',
  'country.CA': 'Canada',
  'country.MX': 'Mexique',
  'country.GB': 'Royaume-Uni',
  'country.DE': 'Allemagne',
  'country.FR': 'France',
  'country.other': 'Autre',

  // Business type (supplier — CompanyInfoSection uses businessType.*)

  // Missing keys (added from en/de)
  'common.saving': 'Enregistrement…',
  'common.archive': 'Archiver',
  'scout.missions.industries.placeholder': 'Sélectionner les secteurs',
  'scout.missions.industries.search': 'Rechercher des secteurs...',
  'scout.missions.industries.empty': 'Aucun secteur trouvé',
  'scout.missions.products.placeholder': 'Sélectionner les familles de produits',
  'scout.missions.products.search': 'Rechercher des familles de produits...',
  'scout.missions.products.empty': 'Aucune famille de produits trouvée',
  'scout.search.selectStatus': 'Sélectionner le statut...',
  'scout.dailyPlanning.jokerAdd': 'Utiliser le joker',
  'scout.dailyPlanning.jokerTitle': 'Arrêt joker',
  'scout.dailyPlanning.jokerUsed': 'utilisé',
  'scout.dailyPlanning.jokerLimitReached': 'Limite quotidienne d\'arrêts joker atteinte.',
  'scout.dailyPlanning.jokerCompany': 'Entreprise',
  'scout.dailyPlanning.jokerCompanyPlaceholder': 'Saisir le nom de l\'entreprise',
  'scout.dailyPlanning.jokerReason': 'Motif',
  'scout.dailyPlanning.jokerReasonPlaceholder': 'Pourquoi cet arrêt est-il nécessaire ?',
  'scout.dailyPlanning.jokerCancel': 'Annuler',
  'scout.dailyPlanning.jokerSubmit': 'Utiliser le joker',
  'scout.dailyPlanning.jokerCreateError': 'Impossible de créer l\'arrêt joker.',
  'missions.management.decisionMakerMet': 'Décideur rencontré',
  'missions.management.wonAmount': 'Montant gagné',
  'common.active': 'Actif',
  'common.archived': 'Archivé',
  'common.planned': 'Planifié',
  'missionControl.totalLeads': 'Total des prospects',
  'missionControl.completedLeads': 'Prospects complétés',

  'survey.contact.name': 'Nom',
  'survey.contact.namePlaceholder': 'Saisir le nom',
  'survey.contact.function': 'Fonction / Rôle',
  'survey.contact.functionPlaceholder': 'Saisir la fonction',
  'survey.contact.email': 'E-mail',
  'survey.contact.emailPlaceholder': "Saisir l'adresse e-mail",
  'survey.contact.phone': 'Téléphone',
  'survey.contact.phonePlaceholder': 'Saisir le numéro de téléphone',
  'survey.contact.isDecisionMaker': 'Est décideur ?',
};
